<template>
  <div>
    <h6>{{ cartHeading }}</h6>
    <p>
      {{ totalLabel }}: {{ order.display_total }}
      <small>{{ order.item_count }} {{ order.item_count === 1 ? 'item' : 'items' }}</small>
    </p>
  </div>
</template>

<script>
  export default {
    props: {
      cartHeading: { type: String, default: 'Cart info' },
      totalLabel: { type: String, default: 'Order Subtotal' },
      order: { type: Object, required: true }
    }
  }
</script>
